export default __webpack_public_path__ + "static/media/profile_marker.a12a9f0e.svg";